export default [
  {
    name: 'uploadFile',
    method: 'POST',
    path: '/vue/files/upload'
  }
];

// 文件上传接口
export const uploadFile = '/vue/files/upload';

export const uploadVideo = '/vue/files/upload-video-gen-thumb';
